import {
  ScheduledAgentMessageResponse,
  StafferAgentScheduledMessageKind,
} from "@/types";

// Both templated chains are three sends long.
const CHAIN_LENGTH = 3;

export const scheduledAgentMessages = {
  /** Where a queued send sits in its chain, e.g. "Follow-up 2 of 3". */
  stepLabel: (
    scheduledMessage: Pick<ScheduledAgentMessageResponse, "kind" | "stepIndex">,
  ): string => {
    const name =
      scheduledMessage.kind === StafferAgentScheduledMessageKind.FOLLOW_UP
        ? "Follow-up"
        : "Nudge";
    return `${name} ${(scheduledMessage.stepIndex + 1).toString()} of ${CHAIN_LENGTH.toString()}`;
  },
};
